import { z } from 'zod';
import { AuditFieldsSchema, TenantIdSchema } from '../types/common.types';
import { PaginationQuerySchema } from '../types/pagination.types';

export const PartnerTypeSchema = z.enum(['INDIVIDUAL', 'COMPANY', 'GOVERNMENT', 'NONPROFIT']);
export type PartnerType = z.infer<typeof PartnerTypeSchema>;

export const PartnerSchema = z
  .object({
    id: z.string().uuid(),
    tenantId: TenantIdSchema,
    type: PartnerTypeSchema,
    name: z.string().min(1).max(255),
    taxNumber: z.string().nullable(),
    vatNumber: z.string().nullable(),
    email: z.string().email().nullable(),
    phone: z.string().nullable(),
    address: z
      .object({
        country: z.string().length(2).default('HU'),
        postalCode: z.string(),
        city: z.string(),
        street: z.string(),
      })
      .nullable(),
    notes: z.string().max(2000).nullable(),
    isActive: z.boolean().default(true),
  })
  .merge(AuditFieldsSchema);
export type Partner = z.infer<typeof PartnerSchema>;

export const PartnerCreateSchema = PartnerSchema.omit({
  id: true,
  tenantId: true,
  createdAt: true,
  updatedAt: true,
  createdBy: true,
  updatedBy: true,
}).partial({
  taxNumber: true,
  vatNumber: true,
  email: true,
  phone: true,
  address: true,
  notes: true,
});
export type PartnerCreate = z.infer<typeof PartnerCreateSchema>;

export const PartnerUpdateSchema = PartnerCreateSchema.partial();
export type PartnerUpdate = z.infer<typeof PartnerUpdateSchema>;

export const PartnerListQuerySchema = PaginationQuerySchema.extend({
  search: z.string().optional(),
  type: PartnerTypeSchema.optional(),
  isActive: z.coerce.boolean().optional(),
});
export type PartnerListQuery = z.infer<typeof PartnerListQuerySchema>;
